<template>
  <div class="dynamic">
    <indexTitle>
        <template v-slot:title>
            实验室动态
        </template>
        <template v-slot:eng>
            Laboratory dynamics
        </template>
        <template v-slot:more>
            <a @click="$router.push({ path: '/dynamic', query: { subtitle: 'sysdt2' } })">更多</a>
        </template>
    </indexTitle>
    <div class="dynamic-body" :class="'dynamic-body--cols-' + displayCount">
        <div class="photo">
        <img :src="bannerImage" />
        </div>
        <div class="content">
          <ul class="sysdt-list">
            <li v-for="(item, index) in newsList.slice(0, displayCount)" :key="index" @click="handleNewsClick(item)">
              <a href="javascript:;">
                <div class="topic">{{item.title}}</div>
                <div class="date">
                <span>{{ formatDate(item.publishTime, 'monthDay') }} </span>/ {{ formatDate(item.publishTime, 'year') }}
                </div>
              </a>
            </li>
          </ul>
        </div>
    </div>
  </div>
</template>

<script>
import { getBanner } from '@/api/banner.js'
import { getNewsList } from '@/api/dynamic.js'

export default {
  name: 'indexDynamic',
  data () {
    return {
      bannerImage: '',
      newsList: []
    }
  },
  mounted () {
    // 页面加载时获取首页 banner（zjsys = 首页）
    this.getBannerData('sysdt1')
    this.fetchNewsData()
  },
  computed: {
    displayCount () {
      return Math.min(this.newsList.length, 5)
    }
  },
  methods: {
    async getBannerData (subtitle) {
      try {
        const res = await getBanner(subtitle)
        if (res?.data?.imageUrl) {
          const imgPath = res.data.imageUrl
          this.bannerImage = this.$baseUrl + imgPath
        }
      } catch (err) {
        console.error('获取banner失败：', err)
      }
    },
    async fetchNewsData () {
      try {
        const res = await getNewsList()
        if (res?.code === 1 && res.data && Array.isArray(res.data.rows)) {
          this.newsList = res.data.rows
        }
      } catch (err) {
        console.error('获取实验室动态失败:', err)
      }
    },
    handleNewsClick (item) {
      // 填写了链接则直接跳转，否则进入新闻详情
      if (item.link) {
        window.open(item.link, '_blank')
      } else {
        this.$router.push({ path: '/dynamic/news', query: { subtitle: 'sysdt2', id: item.id } })
      }
    },
    formatDate (timeStr, type) {
      if (!timeStr) return ''
      const date = new Date(timeStr)
      const y = date.getFullYear()
      const m = (date.getMonth() + 1).toString().padStart(2, '0')
      const d = date.getDate().toString().padStart(2, '0')
      if (type === 'year') return y
      if (type === 'monthDay') return `${m}-${d}`
      return `${m}-${d} / ${y}`
    }
  }
}
</script>

<style lang="less">
.dynamic{
    height:482px;
    padding:20px 80px;
    background: linear-gradient(0deg, #ECF1F8, #FFFFFF);
    .dynamic-body{
        display: flex;
        justify-content: space-between;
    }
    .photo{
        width:46%;
        max-width:503px;
        height:293px;
        border-radius: var(--radius-md);
        overflow: hidden;
        flex-shrink: 0;
        img{
            width:100%;
            height:100%;
            object-fit: cover;
        }
    }
    .content{
        width: 48%;
        max-width:502px;
        .sysdt-list{
            display: flex;
            flex-direction: column;
            height: 293px;
        }
        ul li{
            flex: 1;
            border-bottom: 1px solid #dfe3ee;
            padding: 10px 0;
            position: relative;
            cursor: pointer;
            border-radius: 10px;
            transform-origin: left center;
            transition:
              transform 0.32s cubic-bezier(0.22, 1, 0.36, 1),
              background-color 0.32s cubic-bezier(0.22, 1, 0.36, 1),
              border-color 0.32s cubic-bezier(0.22, 1, 0.36, 1),
              box-shadow 0.32s cubic-bezier(0.22, 1, 0.36, 1);
            display: flex;
            align-items: center;
            a{
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 12px;
            }
            .topic{
            font-weight: bold;
            font-size: 15px;
            color: #000000;
            line-height: 20px;
            margin-bottom: 0;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            flex: 1;
            min-width: 0;
            transition: color 0.25s ease;
            }
            .desc{
                font-size: 12px;
                color: #666666;
                line-height: 22px;
                margin-bottom: 8px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .date{
                font-size: 9px;
                color: #0E6BB6;
                line-height: 17px;
                flex-shrink: 0;
                span{
                    font-size:13px;
                }
            }
            &:hover .topic{
              color:#0E6BB6
            }
            &:hover {
              transform: translateX(8px) scale(1.035);
              background: rgba(255, 255, 255, 0.76);
              border-color: rgba(14, 107, 182, 0.18);
              box-shadow: 0 16px 34px rgba(10, 54, 92, 0.12);
            }
        }
    }
    // 2列：默认样式，保持原padding
    .dynamic-body--cols-2 ul li{
        padding: 21px 0;
    }
    // 3列：适度减小padding
    .dynamic-body--cols-3 ul li{
        padding: 12px 0;
    }
    // 4列：进一步减小padding
    .dynamic-body--cols-4 ul li{
        padding: 8px 0;
    }
    // 5列：继续减小padding
    .dynamic-body--cols-5 ul li{
        padding: 6px 0;
    }
}
</style>
